// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   PREMIUM CONTACT SECTION
=============================== */

.contact-section {
    padding: 120px 0 160px;
    position: relative;
    overflow: hidden;
}

/* ===============================
   SECTION HEADER
=============================== */

.section-header {
    text-align: center;
    margin-bottom: 80px;
    animation: fadeInUp 0.8s ease-out;
}

.section-badge {
    display: inline-block;
    padding: 8px 20px;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(139, 92, 246, 0.4);
    border-radius: 50px;
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 24px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);
}

.section-title {
    font-size: clamp(2rem, 4vw, 3.5rem);
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
    line-height: 1.2;
}

.gradient-text {
    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.section-subtitle {
    font-size: 1.125rem;
    color: rgba(255, 255, 255, 0.75);
    font-weight: 500;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ===============================
   CONTACT CONTAINER
=============================== */

.contact-container {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 50px;
    max-width: 1200px;
    margin: 0 auto;
}

/* ===============================
   FORM WRAPPER
=============================== */

.contact-form-wrapper {
    animation: fadeInLeft 0.8s ease-out;
}

@keyframes fadeInLeft {
    from {
        opacity: 0;
        transform: translateX(-40px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.contact-form {
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(168, 85, 247, 0.05));
    border: 2px solid rgba(139, 92, 246, 0.3);
    border-radius: 28px;
    padding: 50px 45px;
    backdrop-filter: blur(20px);
    box-shadow: 
        0 25px 70px rgba(99, 102, 241, 0.2),
        0 0 0 1px rgba(255, 255, 255, 0.08) inset;
    transition: all 0.5s ease;
}

.contact-form:hover {
    border-color: rgba(168, 85, 247, 0.5);
    box-shadow: 
        0 30px 80px rgba(99, 102, 241, 0.3),
        0 0 0 1px rgba(255, 255, 255, 0.12) inset;
}

/* ===============================
   FORM ELEMENTS
=============================== */

.form-group {
    margin-bottom: 30px;
}

.form-label {
    display: block;
    font-size: 1rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 12px;
}

.form-input,
.form-textarea {
    width: 100%;
    padding: 16px 20px;
    background: rgba(255, 255, 255, 0.05);
    border: 2px solid rgba(139, 92, 246, 0.3);
    border-radius: 14px;
    color: #ffffff;
    font-size: 1rem;
    font-weight: 400;
    transition: all 0.4s ease;
    font-family: inherit;
}

.form-input::placeholder,
.form-textarea::placeholder {
    color: rgba(255, 255, 255, 0.5);
}

.form-input:focus,
.form-textarea:focus {
    outline: none;
    border-color: #a855f7;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 
        0 0 0 4px rgba(168, 85, 247, 0.15),
        0 8px 20px rgba(99, 102, 241, 0.2);
}

.form-textarea {
    resize: vertical;
    min-height: 150px;
}

/* ===============================
   SUBMIT BUTTON
=============================== */

.submit-button {
    width: 100%;
    padding: 18px 36px;
    background: linear-gradient(135deg, #6366f1, #a855f7);
    color: #ffffff;
    font-size: 1.0625rem;
    font-weight: 700;
    border: none;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    box-shadow: 0 10px 35px rgba(99, 102, 241, 0.4);
    position: relative;
    overflow: hidden;
}

.submit-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
}

.submit-button:hover::before {
    left: 100%;
}

.submit-button:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 15px 45px rgba(99, 102, 241, 0.5);
}

.submit-button:active {
    transform: translateY(-1px) scale(1);
}

.submit-button svg {
    transition: transform 0.3s ease;
}

.submit-button:hover svg {
    transform: translateX(4px);
}

/* ===============================
   INFO WRAPPER
=============================== */

.contact-info-wrapper {
    display: flex;
    flex-direction: column;
    gap: 28px;
    animation: fadeInRight 0.8s ease-out;
}

@keyframes fadeInRight {
    from {
        opacity: 0;
        transform: translateX(40px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

/* ===============================
   INFO CARD - DIAGONAL DESIGN
=============================== */

.info-card {
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(168, 85, 247, 0.05));
    border-left: 4px solid;
    border-image: linear-gradient(to bottom, #6366f1, #a855f7) 1;
    padding: 28px 30px;
    display: flex;
    align-items: center;
    gap: 24px;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 0 100%);
}

.info-card:hover {
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.08));
    transform: translateX(8px);
    box-shadow: 
        -8px 15px 40px rgba(99, 102, 241, 0.2),
        0 0 0 1px rgba(255, 255, 255, 0.05) inset;
}

.info-card.highlighted {
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.1));
    border-image: linear-gradient(to bottom, #818cf8, #c084fc) 1;
}

.info-card.highlighted:hover {
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.15));
}

/* ===============================
   INFO ICON
=============================== */

.info-icon {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(99, 102, 241, 0.15);
    border-radius: 14px;
    color: rgba(255, 255, 255, 0.9);
    transition: all 0.4s ease;
    flex-shrink: 0;
    border: 2px solid rgba(139, 92, 246, 0.3);
}

.info-card:hover .info-icon {
    background: linear-gradient(135deg, #6366f1, #a855f7);
    color: #ffffff;
    transform: scale(1.1) rotate(-5deg);
    box-shadow: 0 8px 25px rgba(168, 85, 247, 0.4);
}

/* ===============================
   INFO CONTENT
=============================== */

.info-content {
    flex: 1 1;
}

.info-label {
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.65);
    font-weight: 600;
    margin-bottom: 6px;
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.info-value {
    font-size: 1.125rem;
    color: #ffffff;
    font-weight: 600;
    margin: 0;
}

/* ===============================
   RESPONSIVE
=============================== */

@media (max-width: 992px) {
    .contact-container {
        grid-template-columns: 1fr;
        gap: 50px;
    }

    .contact-section {
        padding: 80px 0 120px;
    }

    .section-header {
        margin-bottom: 70px;
    }
}

@media (max-width: 768px) {
    .contact-form {
        padding: 42px 36px;
    }

    .form-group {
        margin-bottom: 26px;
    }

    .info-card {
        padding: 24px 26px;
    }

    .info-icon {
        width: 52px;
        height: 52px;
    }

    .info-icon svg {
        width: 20px;
        height: 20px;
    }
}

@media (max-width: 480px) {
    .contact-form {
        padding: 36px 28px;
    }

    .submit-button {
        font-size: 1rem;
        padding: 16px 32px;
    }

    .info-card {
        clip-path: polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 0 100%);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContactSection.css"],"names":[],"mappings":"AAAA;;iCAEiC;;AAEjC;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;iCAEiC;;AAEjC;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;iCAEiC;;AAEjC;IACI,mCAAmC;AACvC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,sFAAsF;IACtF,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B;;iDAE6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC;;iDAE6C;AACjD;;AAEA;;iCAEiC;;AAEjC;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,qCAAqC;IACrC;;0CAEsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;iCAEiC;;AAEjC;IACI,WAAW;IACX,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;iCAEiC;;AAEjC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;iCAEiC;;AAEjC;IACI,uFAAuF;IACvF,sBAAsB;IACtB,4DAA4D;IAC5D,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kDAAkD;IAClD,0EAA0E;AAC9E;;AAEA;IACI,uFAAuF;IACvF,0BAA0B;IAC1B;;iDAE6C;AACjD;;AAEA;IACI,sFAAsF;IACtF,4DAA4D;AAChE;;AAEA;IACI,sFAAsF;AAC1F;;AAEA;;iCAEiC;;AAEjC;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAyB;IACzB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,mCAAmC;IACnC,8CAA8C;AAClD;;AAEA;;iCAEiC;;AAEjC;IACI,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;;iCAEiC;;AAEjC;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,wEAAwE;IAC5E;AACJ","sourcesContent":["/* ===============================\n   PREMIUM CONTACT SECTION\n=============================== */\n\n.contact-section {\n    padding: 120px 0 160px;\n    position: relative;\n    overflow: hidden;\n}\n\n/* ===============================\n   SECTION HEADER\n=============================== */\n\n.section-header {\n    text-align: center;\n    margin-bottom: 80px;\n    animation: fadeInUp 0.8s ease-out;\n}\n\n.section-badge {\n    display: inline-block;\n    padding: 8px 20px;\n    background: rgba(99, 102, 241, 0.15);\n    border: 1px solid rgba(139, 92, 246, 0.4);\n    border-radius: 50px;\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 0.875rem;\n    font-weight: 600;\n    margin-bottom: 24px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);\n}\n\n.section-title {\n    font-size: clamp(2rem, 4vw, 3.5rem);\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 16px;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n}\n\n.gradient-text {\n    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.section-subtitle {\n    font-size: 1.125rem;\n    color: rgba(255, 255, 255, 0.75);\n    font-weight: 500;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* ===============================\n   CONTACT CONTAINER\n=============================== */\n\n.contact-container {\n    display: grid;\n    grid-template-columns: 1.2fr 1fr;\n    gap: 50px;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n/* ===============================\n   FORM WRAPPER\n=============================== */\n\n.contact-form-wrapper {\n    animation: fadeInLeft 0.8s ease-out;\n}\n\n@keyframes fadeInLeft {\n    from {\n        opacity: 0;\n        transform: translateX(-40px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.contact-form {\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(168, 85, 247, 0.05));\n    border: 2px solid rgba(139, 92, 246, 0.3);\n    border-radius: 28px;\n    padding: 50px 45px;\n    backdrop-filter: blur(20px);\n    box-shadow: \n        0 25px 70px rgba(99, 102, 241, 0.2),\n        0 0 0 1px rgba(255, 255, 255, 0.08) inset;\n    transition: all 0.5s ease;\n}\n\n.contact-form:hover {\n    border-color: rgba(168, 85, 247, 0.5);\n    box-shadow: \n        0 30px 80px rgba(99, 102, 241, 0.3),\n        0 0 0 1px rgba(255, 255, 255, 0.12) inset;\n}\n\n/* ===============================\n   FORM ELEMENTS\n=============================== */\n\n.form-group {\n    margin-bottom: 30px;\n}\n\n.form-label {\n    display: block;\n    font-size: 1rem;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.9);\n    margin-bottom: 12px;\n}\n\n.form-input,\n.form-textarea {\n    width: 100%;\n    padding: 16px 20px;\n    background: rgba(255, 255, 255, 0.05);\n    border: 2px solid rgba(139, 92, 246, 0.3);\n    border-radius: 14px;\n    color: #ffffff;\n    font-size: 1rem;\n    font-weight: 400;\n    transition: all 0.4s ease;\n    font-family: inherit;\n}\n\n.form-input::placeholder,\n.form-textarea::placeholder {\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.form-input:focus,\n.form-textarea:focus {\n    outline: none;\n    border-color: #a855f7;\n    background: rgba(255, 255, 255, 0.08);\n    box-shadow: \n        0 0 0 4px rgba(168, 85, 247, 0.15),\n        0 8px 20px rgba(99, 102, 241, 0.2);\n}\n\n.form-textarea {\n    resize: vertical;\n    min-height: 150px;\n}\n\n/* ===============================\n   SUBMIT BUTTON\n=============================== */\n\n.submit-button {\n    width: 100%;\n    padding: 18px 36px;\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    color: #ffffff;\n    font-size: 1.0625rem;\n    font-weight: 700;\n    border: none;\n    border-radius: 14px;\n    cursor: pointer;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    box-shadow: 0 10px 35px rgba(99, 102, 241, 0.4);\n    position: relative;\n    overflow: hidden;\n}\n\n.submit-button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n    transition: left 0.6s ease;\n}\n\n.submit-button:hover::before {\n    left: 100%;\n}\n\n.submit-button:hover {\n    transform: translateY(-3px) scale(1.02);\n    box-shadow: 0 15px 45px rgba(99, 102, 241, 0.5);\n}\n\n.submit-button:active {\n    transform: translateY(-1px) scale(1);\n}\n\n.submit-button svg {\n    transition: transform 0.3s ease;\n}\n\n.submit-button:hover svg {\n    transform: translateX(4px);\n}\n\n/* ===============================\n   INFO WRAPPER\n=============================== */\n\n.contact-info-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n    animation: fadeInRight 0.8s ease-out;\n}\n\n@keyframes fadeInRight {\n    from {\n        opacity: 0;\n        transform: translateX(40px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n/* ===============================\n   INFO CARD - DIAGONAL DESIGN\n=============================== */\n\n.info-card {\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(168, 85, 247, 0.05));\n    border-left: 4px solid;\n    border-image: linear-gradient(to bottom, #6366f1, #a855f7) 1;\n    padding: 28px 30px;\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 0 100%);\n}\n\n.info-card:hover {\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.08));\n    transform: translateX(8px);\n    box-shadow: \n        -8px 15px 40px rgba(99, 102, 241, 0.2),\n        0 0 0 1px rgba(255, 255, 255, 0.05) inset;\n}\n\n.info-card.highlighted {\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.1));\n    border-image: linear-gradient(to bottom, #818cf8, #c084fc) 1;\n}\n\n.info-card.highlighted:hover {\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.15));\n}\n\n/* ===============================\n   INFO ICON\n=============================== */\n\n.info-icon {\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(99, 102, 241, 0.15);\n    border-radius: 14px;\n    color: rgba(255, 255, 255, 0.9);\n    transition: all 0.4s ease;\n    flex-shrink: 0;\n    border: 2px solid rgba(139, 92, 246, 0.3);\n}\n\n.info-card:hover .info-icon {\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    color: #ffffff;\n    transform: scale(1.1) rotate(-5deg);\n    box-shadow: 0 8px 25px rgba(168, 85, 247, 0.4);\n}\n\n/* ===============================\n   INFO CONTENT\n=============================== */\n\n.info-content {\n    flex: 1;\n}\n\n.info-label {\n    font-size: 0.875rem;\n    color: rgba(255, 255, 255, 0.65);\n    font-weight: 600;\n    margin-bottom: 6px;\n    display: block;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.info-value {\n    font-size: 1.125rem;\n    color: #ffffff;\n    font-weight: 600;\n    margin: 0;\n}\n\n/* ===============================\n   RESPONSIVE\n=============================== */\n\n@media (max-width: 992px) {\n    .contact-container {\n        grid-template-columns: 1fr;\n        gap: 50px;\n    }\n\n    .contact-section {\n        padding: 80px 0 120px;\n    }\n\n    .section-header {\n        margin-bottom: 70px;\n    }\n}\n\n@media (max-width: 768px) {\n    .contact-form {\n        padding: 42px 36px;\n    }\n\n    .form-group {\n        margin-bottom: 26px;\n    }\n\n    .info-card {\n        padding: 24px 26px;\n    }\n\n    .info-icon {\n        width: 52px;\n        height: 52px;\n    }\n\n    .info-icon svg {\n        width: 20px;\n        height: 20px;\n    }\n}\n\n@media (max-width: 480px) {\n    .contact-form {\n        padding: 36px 28px;\n    }\n\n    .submit-button {\n        font-size: 1rem;\n        padding: 16px 32px;\n    }\n\n    .info-card {\n        clip-path: polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 0 100%);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
